import type { PortfolioItem, PortfolioImage } from "@/os/components/PortfolioItemSheet";

const pid = (n: string) => `pf-${n}`;

export const mockPortfolioItems: PortfolioItem[] = [
  {
    id: pid("aurora"),
    project_name_es: "Plataforma de Banca Digital Aurora",
    project_name_en: "Aurora Digital Banking Platform",
    client_name: "Aurora Financial Group",
    country: "US",
    description_es:
      "Diseñamos y desarrollamos una plataforma de banca digital de extremo a extremo con onboarding biométrico, dashboards personalizados y motor de recomendaciones basado en IA. Reducimos el tiempo de apertura de cuenta de 7 días a 9 minutos.",
    description_en:
      "We designed and built an end-to-end digital banking platform featuring biometric onboarding, personalized dashboards, and an AI-powered recommendation engine. Account opening time dropped from 7 days to 9 minutes.",
    testimonial_es:
      "Smart Canvas no solo entregó una plataforma impecable, transformó cómo nuestros clientes perciben la banca. El equipo se sintió como una extensión natural del nuestro.",
    testimonial_en:
      "Smart Canvas didn't just deliver a polished platform — they transformed how our customers experience banking. The team felt like a natural extension of ours.",
    manager_name: "Helena Marsh",
    manager_position_es: "VP de Producto Digital",
    manager_position_en: "VP of Digital Product",
    status: "delivered",
    order_index: 0,
  },
  {
    id: pid("northroute"),
    project_name_es: "Sistema Operativo de Logística NorthRoute",
    project_name_en: "NorthRoute Logistics OS",
    client_name: "NorthRoute Cargo",
    country: "CA",
    description_es:
      "Construimos un sistema operativo de logística que orquesta más de 4,000 envíos diarios entre puertos, almacenes y última milla. Incluye visibilidad en tiempo real, optimización de rutas y un copiloto de IA para coordinadores.",
    description_en:
      "We built a logistics operating system orchestrating 4,000+ daily shipments across ports, warehouses, and last mile. It includes real-time visibility, route optimization, and an AI copilot for dispatchers.",
    testimonial_es:
      "Pasamos de hojas de cálculo y radios a un centro de mando moderno. Smart Canvas entendió nuestra operación mejor que muchos veteranos del sector.",
    testimonial_en:
      "We went from spreadsheets and radios to a modern command center. Smart Canvas understood our operation better than many industry veterans.",
    manager_name: "Daniel Okafor",
    manager_position_es: "Director de Operaciones",
    manager_position_en: "Operations Director",
    status: "in_development",
    order_index: 1,
  },
  {
    id: pid("helix"),
    project_name_es: "Suite Clínica Helix",
    project_name_en: "Helix Clinical Suite",
    client_name: "Helix Health Network",
    country: "ES",
    description_es:
      "Suite clínica HIPAA/GDPR compliant para una red de 32 clínicas: historial unificado, telemedicina, agenda inteligente y panel para pacientes. Migración sin downtime desde 4 sistemas legacy.",
    description_en:
      "A HIPAA/GDPR-compliant clinical suite for a network of 32 clinics: unified records, telemedicine, smart scheduling, and a patient portal. Zero-downtime migration from 4 legacy systems.",
    testimonial_es:
      "La curva de adopción fue la más rápida que hemos visto. Nuestros médicos recuperaron horas cada semana para enfocarse en lo que importa: el paciente.",
    testimonial_en:
      "The adoption curve was the fastest we've ever seen. Our clinicians got hours back every week to focus on what matters: the patient.",
    manager_name: "Dra. Marisol Vega",
    manager_position_es: "Directora Médica",
    manager_position_en: "Chief Medical Officer",
    status: "continuous_improvement",
    order_index: 2,
  },
  {
    id: pid("lumen"),
    project_name_es: "Comercio Componible Lumen",
    project_name_en: "Lumen Composable Commerce",
    client_name: "Lumen Retail Co.",
    country: "MX",
    description_es:
      "Replatforming completo a comercio componible headless para una marca omnicanal: storefront ultrarrápido, PIM unificado y experimentación A/B nativa. +38% en conversión y -52% en tiempo de carga.",
    description_en:
      "Full replatforming to headless composable commerce for an omnichannel brand: lightning-fast storefront, unified PIM, and native A/B experimentation. +38% conversion and -52% load time.",
    testimonial_es:
      "El nuevo storefront se siente como una marca de lujo y rinde como un equipo de ingeniería de élite. Smart Canvas elevó el listón.",
    testimonial_en:
      "The new storefront feels like a luxury brand and performs like an elite engineering team. Smart Canvas raised the bar.",
    manager_name: "Camila Restrepo",
    manager_position_es: "Jefa de Ecommerce",
    manager_position_en: "Head of Ecommerce",
    status: "delivered",
    order_index: 3,
  },
];

export const mockPortfolioImages: PortfolioImage[] = mockPortfolioItems.flatMap((it) =>
  Array.from({ length: 4 }).map((_, i) => ({
    id: `${it.id}-img-${i}`,
    item_id: it.id,
    storage_path: `dummy/${it.id}/${i}.jpg`,
    url: `https://picsum.photos/seed/sc-${it.order_index}-${i}/1600/1000`,
    caption: null,
    order_index: i,
  })),
);
